import { calcLevel, convertRaw } from 'utils/beacon'
import { ITank, ITankInfo } from 'types'
import { TRACKERTYPES } from 'utils/constants'
export const pad = (s: number | string, size: number): string => {
  let r = s.toString()
  while (r.length < size) {
    r = '0' + r
  }
  return r
}

export const toTitleCase = (str: string): string => {
  if (str) {
    return str.replace(
      /\b\w+\b/g,
      (txt: string): string => `${txt.charAt(0).toUpperCase()}${txt.substr(1).toLowerCase()}`,
    )
  }
  return ''
}

export const normaliseID = (str: string): string => (str || '').replace(/^0+/, '')
//Allow leading zeros - sh in edit mode
export const normaliseIDwithZero = (str: string): string => (str || '').replace(/^/, '')

export const getTankInfo = (tank: ITank): any => {
  const sensor = tank.sensor
  const settings = tank.settings
  const info: ITankInfo = {
    uom: 'm3',
    value: 0,
    valuepast: 0
  }

  if (settings) {
    if (settings.reorder) {
      info.reorder = settings.reorder
    }
    if (settings.product) {
      info.uom = settings.product.uom || 'm3'
    }
  }

  //for sorting - use common lastUpdatedDashBoard for both tracker and non tracker types
  if (tank.type != undefined && TRACKERTYPES.includes(tank.type.toString().toLowerCase()) && tank.location) {
    info.lastUpdatedDashBoard = tank.location.datetime
  }

  if (sensor) {
    info.data = convertRaw(sensor.raw)
    if (tank.capacity != undefined && tank.capacity == 181) {
      info.data.capacity = tank.capacity;
    }
    if (tank.pvalue != undefined) {
      info.data.pvalue = tank.pvalue;
    }
    info.lastUpdated = sensor.datetime

    // For non tracker types werer sensor is present
    if (tank.type != undefined && !TRACKERTYPES.includes(tank.type.toString().toLowerCase())) {
      info.lastUpdatedDashBoard = sensor.datetime
    }
    info.value = calcLevel({
      ...info.data,
      dporhe: tank.dporhe,
    }, settings)
  }
  else {
    if (tank.type != undefined && TRACKERTYPES.includes(tank.type.toString().toLowerCase())) {
      //To display main battery for tracker types
      if (tank.locationRaw != undefined) {
        let data: any = {}
        let locationRaw = tank.locationRaw;
        data.mbat = parseInt(locationRaw.substring(16, 18), 16) / 63.75;
        data.type = tank.type.toString();
        info.data = data;
      }
    }
  }
  if (tank.deliverydatetime !== undefined) {
    var date1 = new Date(tank.deliverydatetime);
    var date2 = new Date();
    var Difference_In_Time = date2.getTime() - date1.getTime();
    var Difference_In_Days = Math.floor(Difference_In_Time / (1000 * 3600 * 24));
    info.assetnoofdays = Difference_In_Days + 1; //Added 1 in days
  }

  // For 48 hrs ago level
  if (tank.pastLevelRaw != undefined) {
    info.dataPast = convertRaw(tank.pastLevelRaw)

    if (tank.capacity != undefined && tank.capacity == 181) {
      info.dataPast.capacity = tank.capacity;
    }

    info.valuepast = calcLevel({
      ...info.dataPast,
      dporhe: tank.dporhe,
    }, settings)
  }
  else {
    //To display N/A
    info.valuepast = undefined;
  }
  return info
}

export const transformTank = (tank: ITank): ITank => {
  if (!tank) return tank
  return {
    ...tank,
    info: getTankInfo(tank),
  }
}
export const getGeoInfo = (tank: ITank): any => {
  if (!tank || !tank.location) return null
  return {
    tank,
    latitude: tank.location.lat,
    longitude: tank.location.lng,
  }
}

export const getGeoInfoTracker = (tank: ITank): any => {
  if (!tank || !tank.location) return null
  return {
    tank,
    lat: tank.location.lat,
    lng: tank.location.lng,
  }
}

export const millisecondsToDate = (milliseconds: number): string => {
  return new Date(milliseconds).toLocaleDateString()
}

export const getTankLevelColour = (value: number): string => {
  if (value > 200) {
    return '#e20015'
  }

  let pct = value
  if (pct > 1) {
    pct = 1
  } else if (pct < 0) {
    pct = 0
  }

  const percentColors = [
    { pct: 0.0, color: { r: 0xe2, g: 0x00, b: 0x15 } },
    { pct: 0.25, color: { r: 0xff, g: 0x7f, b: 0x50 } },
    { pct: 0.5, color: { r: 0xff, g: 0xbb, b: 0x00 } },
    { pct: 0.75, color: { r: 0x14, g: 0xce, b: 0x50 } },
    { pct: 1.0, color: { r: 0, g: 0x9b, b: 32 } },
  ]

  for (let i = 1; i < percentColors.length; i++) {
    if (pct <= percentColors[i].pct) {
      const lower = percentColors[i - 1]
      const upper = percentColors[i]
      const range = upper.pct - lower.pct
      const rangePct = (pct - lower.pct) / range
      const pctLower = 1 - rangePct
      const pctUpper = rangePct
      const color = {
        r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
        g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
        b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper),
      }
      return 'rgb(' + [color.r, color.g, color.b].join(',') + ')'
    }
  }
  return 'rgb(0,0,0)'
}

export const dateString = (datetime: number, showTime?: boolean): string => {
  let date = new Date(datetime)
  let dateString = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()

  if (showTime) {
    dateString += ' ' + pad(date.getHours(), 2) + ':' + pad(date.getMinutes(), 2)
  }
  return dateString

}

export const dateStringYYYYMMDD = (date: Date): string => {
  const month = date.getMonth() + 1
  const day = date.getDate()
  return `${date.getFullYear()}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`
}

export const timeString = (datetime: number) => {
  let date = new Date(datetime)
  return pad(date.getHours(), 2) + ':' + pad(date.getMinutes(), 2)
}
